package com.xtream.composeapp.presentation.ui.content

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyGridState
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.focusRestorer
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.paging.compose.LazyPagingItems
import androidx.paging.compose.itemContentType
import androidx.paging.compose.itemKey
import com.xtream.composeapp.platform.PlatformType
import com.xtream.composeapp.platform.currentPlatform
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.view_all
import com.xtream.data_kmp.dto.BaseStream
import com.xtream.data_kmp.dto.CategoryBase
import com.xtream.data_kmp.dto.CategoryWithStream
import com.xtream.ui.platform.adaptiveValue
import com.xtream.ui.ui.widget.FocusPositioner
import com.xtream.ui.ui.widget.LazyContentRow
import org.jetbrains.compose.resources.stringResource


@Composable
fun ContentScreen(
    title: @Composable (() -> Unit)?=null,
    actions: @Composable (RowScope.() -> Unit)?=null,
    rowItemFraction: Float = 50f,
    onCategoryClicked: ((CategoryBase?) -> Unit)? = null,
    requestFocusOnStart: Boolean = false,
    carousel: (@Composable () -> Unit)? = null,
    rowActionTitle: String? = stringResource( Res.string.view_all),
    contentPadding: PaddingValues = PaddingValues(),

    rowsContentPadding: PaddingValues? =null,
    rowHeight: Dp = 150.dp,
    listState: LazyListState = rememberLazyListState(),

    lazyPagingItems: LazyPagingItems<out CategoryWithStream<out Any, out CategoryBase>>,
    buildExtraContent:  @Composable ((item:Any?, title:String?,rowFocusRequester: FocusRequester?, focusRequester:FocusRequester? ) -> Unit)={ _, _,_,_->},
    buildRowContent:  @Composable ((item:Any?, columnFocusRequester: FocusRequester?, rowFocusRequester: FocusRequester?, focusRequester:FocusRequester?,index:Int, rowListState: LazyListState ) -> Unit)={ _, _,_,_,_,_->},


    ){




    val columnFocusRequester = remember {  FocusRequester()  }
    val firstRowFocusRequester = remember {  FocusRequester()  }
    var hasRequestedStartFocus by rememberSaveable { mutableStateOf(false) }
    LaunchedEffect(requestFocusOnStart) {
        if (requestFocusOnStart && !hasRequestedStartFocus) {
            columnFocusRequester.requestFocus()
            hasRequestedStartFocus = true
        }
    }

    val showRowActionTitle = currentPlatform==PlatformType.DESKTOP ||  adaptiveValue( expandedValue = false, compactValue = true, default = true)

    Scaffold(
        topBar = {
            if(title!=null || actions!=null) {
                @OptIn(ExperimentalMaterial3Api::class)

                TopAppBar(
                    colors = TopAppBarDefaults.topAppBarColors(
                        containerColor = MaterialTheme.colorScheme.background
                    ),
                    title = { title?.invoke() },
                    actions = { actions?.invoke(this) }
                )
            }
        }
    ) { innerPadding->



        LazyColumn(
            state= listState,
            contentPadding =  PaddingValues(top=innerPadding.calculateTopPadding()+contentPadding.calculateTopPadding()),
            modifier = Modifier
                .focusRequester(columnFocusRequester)
                .focusRestorer(firstRowFocusRequester)
        ) {
            if(carousel!=null)
                item("Carousel") {
                    carousel.invoke()

                }




            items(lazyPagingItems.itemCount,
                key = lazyPagingItems.itemKey{ it->it.category.categoryId?:it.hashCode()},
                contentType = {
                    lazyPagingItems.itemContentType{ it.category}
                }
            ) {it->
                val category = lazyPagingItems[it]
                val rowFocusRequester = if (it==0) firstRowFocusRequester else remember { FocusRequester() }
                val firstItemFocusRequester = remember { FocusRequester() }
                val listScrollState = rememberSaveable(saver = LazyListState.Saver) {
                    LazyListState()
                }

                FocusPositioner(
                    parentFraction = rowItemFraction,
                    childFraction = 0f,
                ) {
                    LazyContentRow(
                        state = listScrollState,
                      //TODO  focusRequester =rowFocusRequester,
                        focusRestorer = firstItemFocusRequester,
                        modifier = Modifier,
                        title =category?.category?.categoryName,
                        contentPadding = rowsContentPadding?:PaddingValues(start = 16.dp, end= 48.dp),
                        actionTitle =if(showRowActionTitle) rowActionTitle else null,
                        onActionClick={ onCategoryClicked?.invoke( category?.category )}){
                        itemsIndexed (
                            category?.streams.orEmpty(),
                            key = {index, item-> (item as? BaseStream?)?.streamId?:index}
                        ){index, item->

                            buildRowContent.invoke( item,columnFocusRequester ,rowFocusRequester,if(index==0) firstItemFocusRequester else null,index, listScrollState)


                        }

                        if (!showRowActionTitle)
                            category?.size?.let {
                                if (it > 7)
                                    item {
                                        buildExtraContent(category.streams.first(), category.category.categoryName, rowFocusRequester, columnFocusRequester )
                                    }
                            }
                    }
                }
            }



        }
    }





}






@Composable
fun ContentGridScreen(
    modifier: Modifier= Modifier,
    title: @Composable (() -> Unit)?=null,
    actions: @Composable (RowScope.() -> Unit)? = null,
    carousel: (@Composable () -> Unit)? = null,
    lazyPagingItems: LazyPagingItems<out BaseStream>,
    numColumns:Int=3,
    scrollState:LazyGridState = rememberLazyGridState(),

    rowIItem:  @Composable (( BaseStream?) -> Unit)={},
){







    Scaffold(
        modifier = modifier,
        topBar = {
            @OptIn(ExperimentalMaterial3Api::class)

            if(title!=null || actions!=null)
                TopAppBar(
                    colors = TopAppBarDefaults.topAppBarColors(
                        containerColor = MaterialTheme.colorScheme.background
                    ),
                    title = { title?.invoke() },
                    actions = { actions?.invoke(this) }
                )
        },
    ) { innerPadding->

        LazyVerticalGrid (
            columns = GridCells.Fixed(numColumns), // 3 columns

            state= scrollState,
            contentPadding = PaddingValues(top=innerPadding.calculateTopPadding()+16.dp, bottom = 24.dp, start = 6.dp, end = 6.dp),
            horizontalArrangement =  Arrangement.spacedBy(6.dp),
            verticalArrangement =  Arrangement.spacedBy(10.dp),
            modifier = Modifier) {
            if(carousel!=null)
                item {
                    carousel()
                }


            items(lazyPagingItems.itemCount,
                key = lazyPagingItems.itemKey{ it->it.streamId},
                contentType = {null
                }
            ) {
                val stream = lazyPagingItems[it]
                rowIItem.invoke( stream)



            }



        }
    }

}



